import React from "react";
import { Modal, Button } from "react-bootstrap";
import cate1 from "../../assets/certificate/cate.jpg";
import neb1 from "../../assets/certificate/neb.jpg";
import cate2 from "../../assets/certificate/CERT.png";
import neb2 from "../../assets/certificate/NEB.png";
import neb3 from "../../assets/certificate/NEB2026.png";
import cate3 from "../../assets/certificate/ALV2026.png";
import html2canvas from "html2canvas";
import downloadbtn from "../../assets/load_16175234.png";
import PropTypes from "prop-types"; // Import PropTypes for validation

const ShowCertificateModel = (props) => {
  console.log(props);
  const handleScreenshot = () => {
    const certificateElement = document.getElementById("certificate-container");
    html2canvas(certificateElement).then((canvas) => {
      //   const ctx = canvas.getContext("2d");

      canvas.toBlob((blob) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${props?.certificateData?.student}_certificate.png`;
        link.click();
        URL.revokeObjectURL(url);
      });
    });
  };

  React.useEffect(() => {
    const certificateElement = document?.getElementById(
      "certificate-container",
    );
    const preventContextMenu = (e) => e.preventDefault();
    certificateElement?.addEventListener("contextmenu", preventContextMenu);

    return () => {
      certificateElement?.removeEventListener(
        "contextmenu",
        preventContextMenu,
      );
    };
  }, []);

  // Conditionally render the certificate image based on batch and board
  const renderCertificateImage = () => {
    if (!props?.certificateData) return null; // Check if certificateData exists before destructuring

    const { batch, board } = props.certificateData;
    //   console.log(batch);

    if (batch === "2025") {
      if (Number(board) === 1) {
        return (
          <img
            src={neb2}
            alt="NEB Certificate 202"
            className="certificate-img"
          />
        );
      } else if (Number(board) === 2) {
        return (
          <img
            src={cate2}
            alt="Cambridge Certificate 2025"
            className="certificate-img"
          />
        );
      }
    } else if (batch === "2024") {
      if (Number(board) === 1) {
        return (
          <img
            src={neb1}
            alt="NEB Certificate 2024"
            className="certificate-img"
          />
        );
      } else if (Number(board) === 2) {
        return (
          <img
            src={cate1}
            alt="Cambridge Certificate 2024"
            className="certificate-img"
          />
        );
      }
    } else if (batch === "2026") {
      if (Number(board) === 1) {
        return (
          <img
            src={neb3}
            alt="NEB Certificate 2026"
            className="certificate-img"
          />
        );
      } else if (Number(board) === 2) {
        return (
          <img
            src={cate3}
            alt="Cambridge Certificate 2026"
            className="certificate-img"
          />
        );
      }
    }

    return null;
  };

  return (
    <Modal
      {...props}
      dialogClassName="modal-90w"
      size="xl"
      onContextMenu="return false"
    >
      <Modal.Header closeButton>
        <Modal.Title className="w-100">
          <div className="head-down">
            {props?.certificateData?.student}
            <Button variant="link" onClick={handleScreenshot}>
              <img
                src={downloadbtn}
                alt="Download Certificate"
                className="btn-downloads"
              />
            </Button>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="clacertificate-model p-0"
        onContextMenu="return false"
      >
        <div
          id="certificate-container"
          className="certificate-container"
          onContextMenu="return false"
        >
          {/* Render the certificate image based on batch and board */}
          {renderCertificateImage()}

          <p className="student-name">{props?.certificateData?.student}</p>
          <p
            style={{ paddingLeft: 12 }}
            className={`certificate-id  ${
              props?.certificateData?.batch === "2025"
                ? "certificate-id-2025"
                : "certificate-id-2024"
            }`}
          >
            {props?.certificateData?.code}
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

// Add prop types validation, allow null or object for certificateData
ShowCertificateModel.propTypes = {
  certificateData: PropTypes.shape({
    student: PropTypes.string,
    batch: PropTypes.string,
    board: PropTypes.string,
    code: PropTypes.string,
  }),
};

export default ShowCertificateModel;
